import { IArticleProps, ISubsectionProps } from "~/lib/types/article.type";
import SideBar from "../navigation/SideBar";
import { useEffect } from "react";
import { trackUserEvent } from "../../utils/analytics";
import { EVENT_CHANNELS, EVENT_TYPES } from "../../utils/analytics.events";
import { useIsMobileUser } from "../../utils/store/useIsMobileUser";
import { runTimeConfig } from "../../utils/runtime-config";
import { useHelpCentreConfig } from "../../../services/queries/variable.queries";
import { ArticleLabel } from "../views/articles/ArticleLabel";
import Breadcrumbs from "../navigation/Breadscrumbs";
import { getTranslationVariable } from "~/lib/utils/helper/getVariableTranslation";
import { useLocation, useSearchParams } from "@remix-run/react";
import { useLocale } from "~/i18n/i18n.client";

const DetailsLayout = ({
  children,
  article,
  selectedSubsection,
  isVisibleBreadCrumb = true,
}: {
  children: React.ReactNode;
  article?: IArticleProps;
  selectedSubsection?: ISubsectionProps;
  isVisibleBreadCrumb?: boolean;
}) => {
  const location = useLocation();
  const { pathname } = location;
  const [searchParams] = useSearchParams();

  const locale = useLocale();
  const { isMobileUser } = useIsMobileUser();
  const HELP_CENTRE_BASE_URL = runTimeConfig.HELP_CENTRE.BASE_URL;
  const { data: helpCentreConfig } = useHelpCentreConfig();

  useEffect(() => {
    if (pathname && pathname.includes("topics")) {
      // get all subsections of topics
      const subSections = helpCentreConfig?.TOPICS?.map(
        (item) => item.subSections
      ).flat();

      const currentTopic = subSections?.find(
        (subSection: ISubsectionProps) =>
          subSection.value == searchParams.get("id")
      );
      trackUserEvent(
        EVENT_TYPES.WEB_SUPPORT_HELP_CENTRE_TOPIC,
        {
          topic_id: searchParams.get("id"),
          topic_name: currentTopic
            ? getTranslationVariable(currentTopic.label, locale)
            : searchParams.get("name"),
          url: `${HELP_CENTRE_BASE_URL}${pathname}`,
          source: isMobileUser ? "App" : "Web",
        },
        [EVENT_CHANNELS.MIXPANEL]
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams]);

  return (
    <>
      <div className="flex flex-col md:grid md:grid-cols-12 md:gap-12">
        <div className="col-span-12 md:col-span-8">
          {selectedSubsection && (
            <>
              <ArticleLabel selectedSubsection={selectedSubsection} />
            </>
          )}

          {isVisibleBreadCrumb && <Breadcrumbs article={article} />}

          {children}
        </div>
        <div className="md:col-span-4 hidden md:block">
          <SideBar {...{ article }} />
        </div>
      </div>
    </>
  );
};

export default DetailsLayout;
